import React, { useState, useEffect } from 'react';
import { Icon, Loading } from '@tencent/spaui';
import { hasFeatureFlag } from '@/services';
import cookie from '@/utils/cookie';
import { AGENCY_UID_COOKIE_NAME } from '@/constants/Constants';
import API from './api';

import './index.less';

// AMS企点客服工具接口协议
// https://doc.weixin.qq.com/doc/w3_AAkAiAbDAK40CTt9xjTSTSUN8q5SO?scode=AJEAIQdfAAoFZIQDZ0AMUAcQaaACg

const TipsDialog = ({ tip }: { tip: number, }) => {
  const [show, setShow] = useState(true);
  const close = (e: any) => {
    e.stopPropagation();
    setShow(false);
  };
  if (show && !!tip) {
    return <div className='help-tips-container'>
      <Icon style={{ marginRight: '4px', verticalAlign: 'text-bottom' }} name="sound-on-outlined"/>
      <span>您有新的留言，请点击查看</span>
      <span onClick={close} className='help-tips-container-close'>x</span>
    </div>;
  }
  return null;
};

export default (props: { account: any }) => {
  const { account } = props;

  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLodaing] = useState(false);
  const [url, setUrl] = useState('');
  const [tip, setTip] = useState<number>(0);
  const showHelp = hasFeatureFlag('is_headphone_feedback');
  const [userSecond, setUserSecond] = useState(true); // 二代用户

  const baseUrl = 'https://wpa1.qq.com/xPQfz3Mw?_type=wpa&qidian=true&DisplayinAIO=yes&wpaShowItemId=123&auth=commonAuth';
  const timestamp = new Date().getTime();
  const source = 5; // 5-服务商系统-已登录
  const token = cookie.get('gdt_protect') || 0;
  const userId = account.user_id;
  const uid = cookie.get(AGENCY_UID_COOKIE_NAME.default) || account.bm_id;
  const uriPath = location.href.split('?')[0];

  const code = btoa(`${timestamp}_${source}_${token}_${userId}_${uid}_${btoa(uriPath)}`);

  const qidian_ex1 = encodeURIComponent(uriPath); // url
  const qidian_ex2 = uid; // 账户uid，广告主ID或者服务商ID或者BM主体ID
  const qidian_ex3 = ''; // 行业名称，广告主账户一二级行业名称，没有行业传空
  const qidian_ex4 = 0; // 广告主账户所属服务商，没有传0
  const qidian_ex5 = 3; // 账户类型：1-直客、2-子客、3-服务商、4-BM账户

  // 获取未读消息数
  const getUnreadNumber = () => {
    API.getTipData({
      source,
      uid,
      user_id: userId,
    }).then((res) => {
      const number = res?.data?.unread_msg_count || 0;
      setTip(number);
    });
  };

  const getPersonalUrl = async () => {
    if (loading) {
      return;
    }
    setLodaing(true);
    setTip(0);
    const res = await API.getPersonalData({
      source,
      uid,
      uri_path: uriPath,
      user_id: userId,
    });

    const {
      data,
      code: resCode,
    } = res;

    setLodaing(false);

    // 接口有异常不打开对话框
    if (resCode !== 0) {
      return;
    }

    let gatherUrl = `${baseUrl}&qidian_ex1=${qidian_ex1}&qidian_ex2=${qidian_ex2}&qidian_ex3=${qidian_ex3}&qidian_ex4=${qidian_ex4}&qidian_ex5=${qidian_ex5}&code=${code}`;
    if (data) {
      const {
        reception_type,
        reception_id,
      } = data;
      if (reception_type) {
        gatherUrl = `${gatherUrl}&reception_id=${reception_id}&reception_type=${reception_type}`;
      }
    }
    setUrl(gatherUrl);
    setShowDialog((prev) => !prev);
  };

  useEffect(() => {
    const handleClick = () => {
      setShowDialog(false);
    };
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  useEffect(() => {
    if (showHelp) {
      getUnreadNumber();
    }
  }, [showHelp]);

  // 获取用户是否是二代用户，二代用户不展示
  useEffect(() => {
    // 如果不在白名单 就不用调了
    if (!showHelp) {
      return;
    }
    API.getPersonalData({
      source,
      uid,
      uri_path: uriPath,
      user_id: userId,
    }).then((res) => {
      // 二代
      setUserSecond(res?.data?.is_user_second_type);
    });
  }, [showHelp]);

  // 二代用户不展示
  // if (userSecond) {
  //   return null;
  // }

  // 不在白名单不展示
  if (!showHelp) {
    return null;
  }

  return (
    [
      <div key='1' className='agency-help__module agency-help__display' onClick={(e) => e.stopPropagation()}>
        {!showDialog
          && <div
            className="agency-help-card"
            onClick={getPersonalUrl}
          >
            <TipsDialog tip={tip}/>
            { loading
              ? <Loading show={true} theme="light" />
              : <>
                <div className="agency-help-card__icon" />
                <p className="agency-help-card__title" data-report='agency-fe-help-btn'>
                  在线咨询
                </p>
                { !!tip && <div className="number-tips">{tip}</div>}
              </>
            }
          </div>
        }
      </div>,
      <div key='2'>
        { showDialog && <div className='help-container'>
          <Icon
            onClick={() => {
              setShowDialog(() => false);
            }}
            name="close-bold-outlined"
            className="help-close-icon"
          />
          <iframe
            src={url}
            width="100%"
            height="600"
           />
        </div>
        }
      </div>,
    ]
  );
};
